import * as React from 'react';
import classNames from 'classnames';
import './radioSelectInput.module.scss';
import { RadioCardNoBorder } from '../../atoms/select/RadioCardNoBorder';

/**
 * セレクターの選択肢一つを表す
 */
type OptionSpec<T> = {
  /**
   * ユーザに対して表示される選択肢のラベル
   */
  label: string;
  /**
   * 選択肢に対応する値（型は任意）
   */
  value: T;
  /**
   * 選択肢のDOM要素に対して、data-valueとして追加される属性。テストで各選択肢を特定する際に用いる
   */
  valueForAttribute?: string;
  metaAttributes?: object;
};

type Props<T> = {
  id?: string;
  options: OptionSpec<T>[];
  value: T;
  widthType?: 's' | 'm';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: T) => any;
  className?: string;
  styleName?: string;
};
export const RadioSelectInput = <T,>({ id, options, value, onChange, widthType = 'm', className }: Props<T>) => {
  return (
    <div id={id} styleName={classNames('select-input', widthType)} className={className}>
      {options.map((o) => (
        <RadioCardNoBorder
          id={`radio-${o.label}`}
          key={String(o.label)}
          checked={value === o.value}
          label={o.label}
          metaAttributes={o.metaAttributes}
          onCheck={(checked) => {
            if (checked) {
              onChange(o.value);
            }
          }}
        />
      ))}
    </div>
  );
};
